var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _rect2, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _rect3, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _rect4, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame427320264(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 646,
    viewBox: "0 0 1440 646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 646,
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.439,
    cy: 35.7399,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.09,
    cy: 86.1042,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.61,
    cy: 46.0417,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.262,
    cy: 96.406,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9493,
    cy: 199.424,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.601,
    cy: 249.788,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.609,
    cy: 48.3309,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 439.26,
    cy: 98.6952,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.615,
    cy: 161.651,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 352.267,
    cy: 212.015,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.317,
    cy: 114.72,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.053,
    cy: 376.844,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.7399,
    cy: 71.7845,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 398.053,
    cy: 266.958,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.904,
    cy: 96.6807,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.799,
    cy: 196.265,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.841,
    cy: 276.39,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.387,
    cy: 161.925,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.038,
    cy: 212.29,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.008,
    cy: 142.466,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.051,
    cy: 222.591,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.2637,
    cy: 107.852,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.915,
    cy: 158.217,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.728,
    cy: 59.7773,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.379,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.0122,
    cy: 356.24,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.87,
    cy: 346.253,
    r: 0.595215,
    transform: "rotate(-105 289.87 346.253)",
    fill: "#D9D9D9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.664,
    cy: 406.604,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.967,
    cy: 379.133,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.689,
    cy: 279.517,
    r: 0.595215,
    transform: "rotate(-105 295.689 279.517)",
    fill: "#D9D9D9"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.21,
    cy: 207.78,
    r: 0.595215,
    transform: "rotate(150 237.21 207.78)",
    fill: "#D9D9D9"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.905,
    cy: 290.995,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.923,
    cy: 341.027,
    r: 0.595215,
    transform: "rotate(-105 220.923 341.027)",
    fill: "#D9D9D9"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1831,
    cy: 312.858,
    r: 0.595215,
    transform: "rotate(45 75.1831 312.858)",
    fill: "#D9D9D9"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.8129,
    cy: 281.489,
    r: 0.595215,
    transform: "rotate(150 8.8129 281.489)",
    fill: "#D9D9D9"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.243,
    cy: 219.432,
    r: 0.595215,
    transform: "rotate(150 171.243 219.432)",
    fill: "#D9D9D9"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.512,
    cy: 373.562,
    r: 0.595215,
    transform: "rotate(45 103.512 373.562)",
    fill: "#D9D9D9"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.619,
    cy: 429.497,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.006,
    cy: 275.73,
    r: 0.595215,
    transform: "rotate(150 250.006 275.73)",
    fill: "#D9D9D9"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.506,
    cy: 282.911,
    r: 0.595215,
    transform: "rotate(45 137.506 282.911)",
    fill: "#D9D9D9"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.556,
    cy: 341.36,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.584,
    cy: 225.201,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.627,
    cy: 305.326,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.7661,
    cy: 116.094,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.418,
    cy: 166.458,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5952,
    cy: 47.3881,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.197,
    cy: 73.5131,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.701,
    cy: 58.6328,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.744,
    cy: 138.758,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.189,
    cy: 219.249,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.231,
    cy: 299.374,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.3711,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.023,
    cy: 160.506,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.172,
    cy: 106.479,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.824,
    cy: 156.843,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 646,
    transform: "translate(449)",
    fill: "#2D2D2D"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 636.439,
    cy: 35.7399,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 871.09,
    cy: 86.1042,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.61,
    cy: 46.0417,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 706.262,
    cy: 96.406,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.949,
    cy: 199.424,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.601,
    cy: 249.788,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.609,
    cy: 48.3309,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 888.26,
    cy: 98.6952,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.615,
    cy: 161.651,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 801.267,
    cy: 212.015,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 833.317,
    cy: 114.72,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.053,
    cy: 376.844,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 544.74,
    cy: 71.7845,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 847.053,
    cy: 266.958,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.904,
    cy: 96.6807,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 874.799,
    cy: 196.265,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 773.841,
    cy: 276.39,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.387,
    cy: 161.925,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 845.038,
    cy: 212.29,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.008,
    cy: 142.466,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 633.051,
    cy: 222.591,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 524.264,
    cy: 107.852,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 758.915,
    cy: 158.217,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 638.728,
    cy: 59.7773,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 873.379,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.012,
    cy: 356.24,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.87,
    cy: 346.253,
    r: 0.595215,
    transform: "rotate(-105 738.87 346.253)",
    fill: "#D9D9D9"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.664,
    cy: 406.604,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 608.967,
    cy: 379.133,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.689,
    cy: 279.517,
    r: 0.595215,
    transform: "rotate(-105 744.689 279.517)",
    fill: "#D9D9D9"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 686.21,
    cy: 207.78,
    r: 0.595215,
    transform: "rotate(150 686.21 207.78)",
    fill: "#D9D9D9"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.905,
    cy: 290.995,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.923,
    cy: 341.027,
    r: 0.595215,
    transform: "rotate(-105 669.923 341.027)",
    fill: "#D9D9D9"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 524.183,
    cy: 312.858,
    r: 0.595215,
    transform: "rotate(45 524.183 312.858)",
    fill: "#D9D9D9"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.813,
    cy: 281.489,
    r: 0.595215,
    transform: "rotate(150 457.813 281.489)",
    fill: "#D9D9D9"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 620.243,
    cy: 219.432,
    r: 0.595215,
    transform: "rotate(150 620.243 219.432)",
    fill: "#D9D9D9"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.512,
    cy: 373.562,
    r: 0.595215,
    transform: "rotate(45 552.512 373.562)",
    fill: "#D9D9D9"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 843.619,
    cy: 429.497,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.006,
    cy: 275.73,
    r: 0.595215,
    transform: "rotate(150 699.006 275.73)",
    fill: "#D9D9D9"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 586.506,
    cy: 282.911,
    r: 0.595215,
    transform: "rotate(45 586.506 282.911)",
    fill: "#D9D9D9"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.556,
    cy: 341.36,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.584,
    cy: 225.201,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.627,
    cy: 305.326,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.766,
    cy: 116.094,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 740.418,
    cy: 166.458,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.595,
    cy: 47.3881,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.197,
    cy: 73.5131,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 804.701,
    cy: 58.6328,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.744,
    cy: 138.758,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 696.189,
    cy: 219.249,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 595.231,
    cy: 299.374,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 501.371,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.023,
    cy: 160.506,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 612.172,
    cy: 106.479,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 846.824,
    cy: 156.843,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 646,
    transform: "translate(898)",
    fill: "#2D2D2D"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 1085.44,
    cy: 35.7399,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 1320.09,
    cy: 86.1042,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.61,
    cy: 46.0417,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 1155.26,
    cy: 96.406,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 954.949,
    cy: 199.424,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189.6,
    cy: 249.788,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 1102.61,
    cy: 48.3309,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 1337.26,
    cy: 98.6952,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 1015.62,
    cy: 161.651,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 1250.27,
    cy: 212.015,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 1282.32,
    cy: 114.72,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296.05,
    cy: 376.844,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 993.74,
    cy: 71.7845,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296.05,
    cy: 266.958,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 1262.9,
    cy: 96.6807,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 1323.8,
    cy: 196.265,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 1222.84,
    cy: 276.39,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 1059.39,
    cy: 161.925,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 1294.04,
    cy: 212.29,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 1183.01,
    cy: 142.466,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 1082.05,
    cy: 222.591,
    r: 0.869929,
    fill: "#D9D9D9"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.264,
    cy: 107.852,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 1207.92,
    cy: 158.217,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 1087.73,
    cy: 59.7773,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 1322.38,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 995.012,
    cy: 356.24,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 1187.87,
    cy: 346.253,
    r: 0.595215,
    transform: "rotate(-105 1187.87 346.253)",
    fill: "#D9D9D9"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 1229.66,
    cy: 406.604,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 1057.97,
    cy: 379.133,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 1193.69,
    cy: 279.517,
    r: 0.595215,
    transform: "rotate(-105 1193.69 279.517)",
    fill: "#D9D9D9"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 1135.21,
    cy: 207.78,
    r: 0.595215,
    transform: "rotate(150 1135.21 207.78)",
    fill: "#D9D9D9"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 1017.9,
    cy: 290.995,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 1118.92,
    cy: 341.027,
    r: 0.595215,
    transform: "rotate(-105 1118.92 341.027)",
    fill: "#D9D9D9"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.183,
    cy: 312.858,
    r: 0.595215,
    transform: "rotate(45 973.183 312.858)",
    fill: "#D9D9D9"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 906.813,
    cy: 281.489,
    r: 0.595215,
    transform: "rotate(150 906.813 281.489)",
    fill: "#D9D9D9"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 1069.24,
    cy: 219.432,
    r: 0.595215,
    transform: "rotate(150 1069.24 219.432)",
    fill: "#D9D9D9"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 1001.51,
    cy: 373.562,
    r: 0.595215,
    transform: "rotate(45 1001.51 373.562)",
    fill: "#D9D9D9"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 1292.62,
    cy: 429.497,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 1148.01,
    cy: 275.73,
    r: 0.595215,
    transform: "rotate(150 1148.01 275.73)",
    fill: "#D9D9D9"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 1035.51,
    cy: 282.911,
    r: 0.595215,
    transform: "rotate(45 1035.51 282.911)",
    fill: "#D9D9D9"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 1252.56,
    cy: 341.36,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 1149.58,
    cy: 225.201,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 1048.63,
    cy: 305.326,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 954.766,
    cy: 116.094,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 1189.42,
    cy: 166.458,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 996.595,
    cy: 47.3881,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 1077.2,
    cy: 73.5131,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 1253.7,
    cy: 58.6328,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 1152.74,
    cy: 138.758,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 1145.19,
    cy: 219.249,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.23,
    cy: 299.374,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 950.371,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 1185.02,
    cy: 160.506,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 1061.17,
    cy: 106.479,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 1295.82,
    cy: 156.843,
    r: 0.366286,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 646,
    transform: "translate(1347)",
    fill: "#2D2D2D"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 1369.61,
    cy: 46.0417,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403.95,
    cy: 199.424,
    r: 1.73986,
    fill: "#D9D9D9"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 1422.26,
    cy: 107.852,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 1422.18,
    cy: 312.858,
    r: 0.595215,
    transform: "rotate(45 1422.18 312.858)",
    fill: "#D9D9D9"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 1355.81,
    cy: 281.489,
    r: 0.595215,
    transform: "rotate(150 1355.81 281.489)",
    fill: "#D9D9D9"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 1403.77,
    cy: 116.094,
    r: 0.595215,
    fill: "#D9D9D9"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 1399.37,
    cy: 110.142,
    r: 0.595215,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame427320264);
export default __webpack_public_path__ + "static/media/Frame 427320264.0ead791b5903c9e9d626e76d40706b1f.svg";
export { ForwardRef as ReactComponent };